import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "135px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-end",
	},
	mobileBigView: {},
	main: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	mainWithFee: {},
	value: {
		minWidth: "40px",
		fontSize: "23px",
		lineHeight: 1.24,
		fontFamily: theme.fonts.bold,
		color: theme.palette.colors.darkSlateBlue,
		wordWrap: "break-word",
	},
	valueFee: {
		minWidth: "40px",
		fontSize: "23px",
		lineHeight: 1.24,
		fontFamily: theme.fonts.bold,
		color: theme.palette.colors.darkSlateBlue,
		wordWrap: "break-word",
	},
	valueWithFee: {
		fontSize: "23px",
		lineHeight: 1.24,
		color: theme.palette.colors.oneMoreGrey,
		textDecoration: "line-through",
	},
	measure: {
		fontSize: "14px",
		lineHeight: 1.42,
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
	},
	measureWithFee: {
		display: "none",
		color: theme.palette.colors.oneMoreGrey,
		textDecoration: "line-through",
	},
	measureFee: {
		fontSize: "14px",
		lineHeight: 1.42,
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
	},
	comments: {
		marginTop: "12px",
	},
	comment: {
		fontSize: "12px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.oneMoreGrey,
		lineHeight: 1.42,
		margin: "0 0 12px 0",
		padding: 0,
		textAlign: "center",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	noFeeComponent: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	noFeeWithFeeComponent: {},
	feeСomponent: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	[`@media (min-width: ${theme.media.lg})`]: {
		value: {
			maxWidth: "134px",
			minWidth: "55px",
		},
		valueFee: {
			maxWidth: "134px",
			minWidth: "55px",
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			width: "105px",
		},
		value: {
			maxWidth: "102px",
			fontSize: "18px",
		},
		valueFee: {
			maxWidth: "102px",
			fontSize: "18px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "101px",
		},
		value: {
			maxWidth: "98px",
			fontSize: "16px",
		},
		valueFee: {
			maxWidth: "98px",
			fontSize: "16px",
		},
		measure: {
			fontSize: "12px",
			// marginLeft: "4px"
		},
		measureWithFee: {
			fontSize: "12px",
			// marginLeft: "4px"
		},
		measureFee: {
			fontSize: "12px",
		},
		comments: {
			marginTop: "6px",
		},
		comment: {
			margin: "0 0 6px 0",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
		},
		main: {
			flexDirection: "row",
			justifyContent: "center",
		},
		mainWithFee: {
			justifyContent: "space-between",
			alignItems: "flex-end",
		},
		noFeeComponent: {
			width: "100%",
			flexDirection: "row",
			alignItems: "flex-end",
			flexWrap: "wrap",
		},
		noFeeWithFeeComponent: {
			width: "50%",
			justifyContent: "flex-start",
			alignItems: "flex-end",
			paddingRight: "2px",
		},
		feeСomponent: {
			width: "50%",
			flexDirection: "row",
			flexGrow: 1,
			textAlign: "end",
			justifyContent: "flex-end",
			alignItems: "flex-end",
			flexWrap: "wrap",
			paddingLeft: "2px",
			columnGap: "4px",
		},
		value: {
			marginRight: "4px",
			fontSize: "22px",
		},
		valueWithFee: {
			minWidth: "0",
			fontSize: "18px",
		},
		valueFee: {
			minWidth: "0",
			fontSize: "22px",
		},
		measure: {
			fontSize: "14px",
		},
		measureWithFee: {
			display: "inline-block",
			fontSize: "14px",
		},
		measureFee: {
			fontSize: "14px",
		},
		comments: {
			display: "none",
		},
		comment: {
			textAlign: "end",
			margin: "0 0 3px 0",
		},
	},
	[`@media (max-width: ${theme.media.verySmall})`]: {
		valueFee: {
			fontSize: "18px",
		},
		valueWithFee: {
			fontSize: "14px",
		},
	},
}));

const PriceComponent = ({ licenseFee, displayPrice, licenceFeeBoolean, measure, comments }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div
				className={classNames(classes.main, {
					[classes.mainWithFee]: licenceFeeBoolean,
				})}
			>
				<div
					className={classNames(classes.noFeeComponent, {
						[classes.noFeeWithFeeComponent]: licenceFeeBoolean,
					})}
				>
					<div
						className={classNames(classes.value, {
							[classes.valueWithFee]: licenceFeeBoolean,
						})}
					>
						{displayPrice}
					</div>
					<span
						className={classNames(classes.measure, {
							[classes.measureWithFee]: licenceFeeBoolean,
						})}
					>
						{measure}
					</span>
				</div>
				{licenceFeeBoolean && (
					<div className={classes.feeСomponent}>
						<div className={classes.valueFee}>{licenseFee}</div>
						<span className={classes.measureFee}>{measure}</span>
					</div>
				)}
			</div>
			{!!comments.length && (
				<div className={classes.comments}>
					{comments.map((comment, index) => {
						return (
							<p className={classes.comment} key={index}>
								{comment}
							</p>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default PriceComponent;
